import TextField from "./textFiled";
import TextareaField from "./textareaField";

const Form = {
  TextField,
  TextareaField,
};

export default Form;
